import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=8adadfcc&scoped=true"
import script from "./SectionEditor.vue?vue&type=script&lang=js"
export * from "./SectionEditor.vue?vue&type=script&lang=js"
import style0 from "./SectionEditor.vue?vue&type=style&index=0&id=8adadfcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adadfcc",
  null
  
)

export default component.exports